import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function Benefits() {
  const benefits = ['Tienes una respuesta clara para la próxima crisis en lugar de improvisar desde el agotamiento y el miedo.', 'Dejas de sentir esa culpa de las 11 PM después de haber gritado más de lo que querías.', 'Entiendes por qué explota tu hijo y dejas de tomártelo como un ataque personal.', 'Sales a la calle con un plan real en lugar de rezar para que no pase nada.', 'Recuperas la sensación de ser el adulto a cargo sin necesitar gritar para lograrlo.', 'Tienes frases exactas listas para usar en lugar de quedarte en blanco en el momento más tenso.'];
  return <section className="py-24 px-6 bg-white" data-id="element-21">
      <div className="max-w-4xl mx-auto" data-id="element-22">
        <FadeIn data-id="element-23">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16 font-serif" data-id="element-24">
            Esto es lo que cambia en tu vida después de leerlo
          </h2>
        </FadeIn>

        <div className="space-y-5" data-id="element-25">
          {benefits.map((benefit, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-26">
              <div className="bg-brand-bg p-6 rounded-2xl shadow-sm border-l-4 border-brand-sage flex items-start gap-4" data-id="element-27">
                <CheckCircle2 className="w-7 h-7 text-brand-sage flex-shrink-0 mt-0.5" data-id="element-28" />
                <p className="text-lg text-gray-800 leading-relaxed" data-id="element-29">
                  {benefit}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}